<acm-header-container></acm-header-container>
<section class="main-content-wrapper flex-fill">
    <router-outlet></router-outlet>
</section>
<acm-footer class="mt-5"></acm-footer>
@if (featureFlags.isFlagEnabled(flags.qaControls)) {
    @defer (when qaPanel.isOpen()) {
        <acm-qa-controls />
    }
}
@if (featureFlags.isFlagEnabled(flags.aiChat) && isAuthenticated()) {
    <acm-ai-chat-shell />
}
